/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// core-js
import 'core-js/stable/array';
import 'core-js/stable/global-this';
import 'core-js/stable/map';
import 'core-js/stable/math';
import 'core-js/stable/number';
import 'core-js/stable/object';
import 'core-js/stable/promise';
import 'core-js/stable/regexp';
import 'core-js/stable/set';
import 'core-js/stable/string';
import 'core-js/stable/symbol';
import 'core-js/stable/url';
import 'core-js/stable/url-search-params';
import 'core-js/stable/weak-map';
import 'core-js/stable/weak-set';

// Ostatní
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'geometry-polyfill';
import 'whatwg-fetch';
